import React from "react";
import SubLayout from "../../components/layouts/SubLayout";

const Recipes = () =>
  (<>
    <SubLayout title="Recipes" />
  </>)
  ;

export default Recipes;